<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page" style="height: 100%;">
    <link :href="`${$root.publicPath}m/global/vendors.bundle.css`" rel="stylesheet" type="text/css" />
    <link :href="`${$root.publicPath}m/global/style.bundle.css`" rel="stylesheet" type="text/css" />
    <div
      class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v2 kt-login--signin"
      id="kt_login"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        :style="{'background-image': `url(${$root.publicPath}m/bg-1.jpg)`}"
      >
        <div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
          <div class="kt-login__container">
            <div class="kt-login__logo">
              <a href="#">
                <img :src="`${$root.publicPath}images/icon/hs-logo-white-nomargin.png`" alt />
              </a>
            </div>
            <div
              class="sufee-alert alert with-close alert-danger alert-dismissible fade show"
              v-if="errors"
            >
              <span class="badge badge-pill badge-danger">Failed</span>
              {{ errors.message }}
            </div>
            <div class="kt-login__signin">
              <div class="kt-login__head">
                <h3 class="kt-login__title"></h3>
              </div>
              <form class="kt-form" method="post" v-on:submit.prevent="doLogin()">
                <div class="input-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Email"
                    name="username"
                    ref="username"
                    v-model.trim="input.username"
                  />
                </div>
                <div class="input-group">
                  <input
                    class="form-control"
                    type="password"
                    placeholder="Password"
                    name="password"
                    v-model="input.password"
                    ref="password"
                  />
                </div>
                <div class="kt-login__actions">
                  <button id="kt_login_signin_submit" class="btn btn-pill kt-login__btn-primary">
                    <span v-html="buttonText"></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      processing: false,
      errorObj: {
        status: false,
        message: null
      }
    }
  },
  computed: {
    buttonText() {
      return this.processing ? '<i class="fas fa-spinner fa-spin"></i>' : 'Login'
    },
    errors() {
      return this.errorObj.status === true ? this.errorObj : null
    },
    formReady() {
      if (this.input.username != "" && this.input.password != "")
        return true
      else
        return false
    },
    isDisabled() {
      return this.input.username == "" || this.input.password == "" || this.processing
    },
  },
  created: function () {
    console.log(this.WebService.login)
  },
  methods: {
    doLogin() {

      if (this.processing === true)
        return

      // Validation
      if (this.input.username == "") {
        this.$refs.username.focus()
        return false
      }

      if (this.input.password == "") {
        this.$refs.password.focus()
        return false
      }

      // Try to login
      this.processing = true
      this.$http
        .post(this.WebService.login, {
          'grant_type': 'password',
          'client_id': process.env.VUE_APP_CLIENT_ID,
          'client_secret': process.env.VUE_APP_CLIENT_SECRET,
          'username': this.input.username,
          'password': this.input.password,
          'scope': '*'
        })
        .then((response) => {

          if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token)
            this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token
            this.$http.defaults.headers.common['Accept'] = 'application/json'
            this.loginSuccess()
          } else {
            this.loginFailed()
          }

        })
        .catch((err) => {
          let message
          if (err.response) {
            message = err.response.data.message
          } else {
            message = err.message
          }
          this.loginFailed(message)
        })
        .finally(() => this.processing = false)


    },
    loginSuccess() {
      this.$router.push({ name: 'system' })
    },
    loginFailed(message = 'Login failed') {
      this.errorObj = {
        status: true,
        message
      }
      this.input.password = ''
    }
  }
}
</script>
<style scoped>
.kt-login.kt-login--v2 {
  background-size: cover;
  background-repeat: no-repeat;
}
.kt-login.kt-login--v2 .kt-login__wrapper {
  padding: 6% 2rem 1rem 2rem;
  margin: 0 auto 2rem auto;
  overflow: hidden;
}
.kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container {
  width: 430px;
  margin: 0 auto;
}
.kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container .kt-login__logo {
  text-align: center;
  margin: 0 auto 4rem auto;
}
.kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container .kt-login__head {
  margin-top: 1rem;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-login__head
  .kt-login__title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  color: #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-login__head
  .kt-login__desc {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}
.kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container .kt-form {
  margin: 4rem auto;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .input-group {
  padding: 0;
  margin: 0 auto;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control {
  height: 46px;
  border-radius: 46px;
  border: none;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1.5rem;
  background: rgba(67, 34, 167, 0.4);
  color: white;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.7);
  opacity: 1;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control.is-valid
  + .valid-feedback,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .form-control.is-invalid
  + .invalid-feedback {
  font-weight: 500;
  font-size: 0.9rem;
  padding-left: 1.6rem;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra {
  padding-left: 7px;
  padding-right: 7px;
  margin: 15px auto;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1rem;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-checkbox {
  font-size: 1rem;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-checkbox
  > span {
  border: 1px solid rgba(255, 255, 255, 0.6);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-checkbox
  input:checked
  ~ span {
  border: 1px solid #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-checkbox
  input:checked
  ~ span:after {
  border: solid #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-login__link {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__extra
  .kt-login__link:hover {
  color: #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions {
  text-align: center;
  margin-top: 7%;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-primary,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary {
  height: 46px;
  display: inline-block;
  text-align: center;
  padding-left: 4rem;
  padding-right: 4rem;
  margin-top: 0.8rem;
  border-radius: 60px;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-color: rgba(255, 255, 255, 0.4);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-primary.active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-primary:active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-primary:hover,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary.active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary:active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary:hover {
  color: #fff;
  border-color: #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary {
  color: rgba(255, 255, 255, 0.4);
  border-color: rgba(255, 255, 255, 0.3);
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary.active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary:active,
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-form
  .kt-login__actions
  .kt-login__btn-secondary:hover {
  color: #fff;
  border-color: #fff;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-login__account {
  text-align: center;
  margin-top: 2rem;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-login__account
  .kt-login__account-msg {
  font-size: 1.1rem;
  font-weight: 500;
  color: #bbabf1;
}
.kt-login.kt-login--v2
  .kt-login__wrapper
  .kt-login__container
  .kt-login__account
  .kt-login__account-link {
  font-size: 1.1rem;
  font-weight: 500;
}

.kt-login.kt-login--v2.kt-login--signin .kt-login__signup {
  display: none;
}

.kt-login.kt-login--v2.kt-login--signin .kt-login__signin {
  display: block;
}

.kt-login.kt-login--v2.kt-login--signin .kt-login__forgot {
  display: none;
}

.kt-login.kt-login--v2.kt-login--signup .kt-login__signup {
  display: block;
}

.kt-login.kt-login--v2.kt-login--signup .kt-login__signin {
  display: none;
}

.kt-login.kt-login--v2.kt-login--signup .kt-login__forgot {
  display: none;
}

.kt-login.kt-login--v2.kt-login--signup .kt-login__account {
  display: none;
}

.kt-login.kt-login--v2.kt-login--forgot .kt-login__signup {
  display: none;
}

.kt-login.kt-login--v2.kt-login--forgot .kt-login__signin {
  display: none;
}

.kt-login.kt-login--v2.kt-login--forgot .kt-login__forgot {
  display: block;
}

@media (max-width: 1024px) {
  .kt-login.kt-login--v2 .kt-login__wrapper {
    padding-top: 5rem;
    width: 100%;
  }
  .kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container {
    margin: 0 auto;
  }
  .kt-login.kt-login--v2
    .kt-login__wrapper
    .kt-login__container
    .kt-login__account {
    margin-top: 10rem;
  }
}

@media (max-width: 768px) {
  .kt-login.kt-login--v2 .kt-login__wrapper {
    width: 100%;
  }
  .kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  .kt-login.kt-login--v2 .kt-login__wrapper .kt-login__container .kt-form {
    width: 100%;
    margin: 0 auto;
  }
  .kt-login.kt-login--v2
    .kt-login__wrapper
    .kt-login__container
    .kt-form
    .form-control {
    background: rgba(67, 34, 167, 0.8);
  }
  .kt-login.kt-login--v2
    .kt-login__wrapper
    .kt-login__container
    .kt-login__actions
    .kt-login__btn-submit {
    padding: 0.8rem 3rem;
  }
  .kt-login.kt-login--v2
    .kt-login__wrapper
    .kt-login__container
    .kt-login__account {
    margin-top: 1.5rem;
  }
}
</style>